import React, { useEffect, useState, Dispatch, SetStateAction } from 'react'
import { Spinner, Col, Row } from 'react-bootstrap'
import { Pagination } from '@mui/material'

type Props = {
  setCurrentPage: Dispatch<SetStateAction<number>>
  setPerPage: Dispatch<SetStateAction<number>>
  setSearchParams: Dispatch<SetStateAction<string>>
  permintaanBuku: any[]
  perPage: number
  totalPage: number
  currentPage: number
  loading: boolean
  bulanAwal: string
  bulanAkhir: string
  tahunAwal: string
  tahunAkhir: string
}

const TablePermintaanBuku: React.FC<Props> = ({
  setCurrentPage,
  setPerPage,
  setSearchParams,
  permintaanBuku,
  perPage,
  totalPage,
  currentPage,
  loading,
  bulanAwal,
  bulanAkhir,
  tahunAwal,
  tahunAkhir
}) => {
  const formatedDate = (tgl_input: string) => {
    const dataObj = new Date(tgl_input)
    const tanggal = dataObj.getDate()
    const bulan = dataObj.getMonth() + 1
    const tahun = dataObj.getFullYear()
    const jam = dataObj.getHours()
    const menit = dataObj.getMinutes()

    const formatedTanggal = tanggal < 10 ? `0${tanggal}` : tanggal
    const formatedBulan = bulan < 10 ? `0${bulan}` : bulan
    const formatedJam = jam < 10 ? `0${jam}` : jam
    const formatedMenit = menit < 10 ? `0${menit}` : menit

    return `${formatedTanggal}/${formatedBulan}/${tahun} ${formatedJam}:${formatedMenit}`
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchParams(e.target.value)
  }

  const handlePerPage = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = parseInt(e.target.value)
    setPerPage(value)
    setCurrentPage(1) // Reset currentPage when perPage changes
  }

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setCurrentPage(newPage)
  }

  return (
    <div className='card'>
      <div className='card-header border-0 pt-6 d-flex align-items-center justify-content-between'>
        <div>
          <input
            type='text'
            className='form-control form-control-solid w-250px ps-13'
            placeholder='Cari...'
            onChange={handleSearch}
          />
        </div>
      </div>
      <h1 className='text-dark fw-bold mb-5 text-center'>Permintaan Buku</h1>

      <h2 className='text-dark fw-bold mb-5 text-center'>
        Periode {bulanAwal} {tahunAwal} - {bulanAkhir} {tahunAkhir}
      </h2>
      <div className='my-1 '></div>
      <div className='py-4 table-responsive'>
        <div className='table-container'>
          <table
            className='table table-hover table-bordered table-striped'
            style={{ margin: '0 auto', width: '90%' }}
          >
            <thead className='table-dark'>
              <tr>
                <th>Username</th>
                <th>Mitra</th>
                <th>Judul</th>
                <th>Penulis</th>
                <th>Penerbit</th>
                <th>Tahun</th>
                <th>ISBN</th>
                <th>Tanggal Input</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8} className='text-center'>
                    <Spinner animation='border' role='status' />
                  </td>
                </tr>
              ) : !permintaanBuku?.length ? (
                <tr>
                  <td colSpan={8} className='text-center'>
                    Data not found.
                  </td>
                </tr>
              ) : (
                permintaanBuku.map((data, index) => (
                  <tr key={index}>
                    <td>{data.nama_user}</td>
                    <td>{data.nama_mitra}</td>
                    <td>{data.judul}</td>
                    <td>{data.penulis}</td>
                    <td>{data.penerbit}</td>
                    <td>{data.tahun}</td>
                    <td>{data.isbn}</td>
                    <td>{formatedDate(data.tgl_input)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Row className='mb-5' style={{ marginRight: '3.7rem' }}>
        <Col
          xs={12}
          md={6}
          className='d-flex align-items-center justify-content-center justify-content-md-start'
        >
          {/* Biarkan kolom ini kosong jika tidak ada yang perlu ditampilkan di sini */}
        </Col>
        <Col
          xs={12}
          md={6}
          className='d-flex justify-content-center justify-content-md-end align-items-center'
        >
          <label htmlFor='perPage' className='me-2'></label>
          <select
            style={{ width: '75px' }}
            id='perPage'
            className='form-select form-select-sm me-2'
            value={perPage}
            onChange={handlePerPage}
          >
            <option value='1'>1</option>
            <option value='5'>5</option>
            <option value='10'>10</option>
            <option value='25'>25</option>
            <option value='50'>50</option>
            <option value='100'>100</option>
          </select>
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={handleChangePage}
            variant='outlined'
            shape='rounded'
          />
        </Col>
      </Row>
    </div>
  )
}

export default TablePermintaanBuku
